export default "__VITE_ASSET__BCPvyPZy__"